import React, { useContext } from 'react';
import { AppContext } from '../Context';

const Footer = () => {
  const { themeColor } = useContext(AppContext);
  return (
    <section className="d-flex justify-content-between footer-container" id="contact">
      <div className="footer flex-grow-1" style={{ backgroundColor: themeColor }}>
        <div className="d-flex justify-content-between flex-grow-1 flex-column flex-lg-row">
          <div className="d-flex flex-column align-items-center align-items-lg-start font-14 footer-line-height">
            <div className="font-16 font-weight-bold">Contact</div>
            <p>1900 Lafayette Street, Suite 200</p>
            <p>Santa Clara, CA 95050</p>
            <p>P: (408) 791-3551</p>
            <p>E: support@payportal.org</p>
          </div>

          <div className="d-flex flex-column align-items-center align-items-lg-start my-4 my-lg-0 font-14 footer-line-height">
            <div className="font-16 font-weight-bold">Services</div>
            <a
              href="https://www.payportal.org/#automatedpayment"
              target="_blank"
              rel="noopener noreferrer">
              Automated Payments
            </a>

            <a
              href="https://www.payportal.org/#b2becosystem"
              target="_blank"
              rel="noopener noreferrer">
              B2B Ecosystem
            </a>

            <a
              href="https://www.payportal.org/#deeplearning"
              target="_blank"
              rel="noopener noreferrer">
              Deep Learning
            </a>
          </div>

          <div className="d-flex flex-column align-items-center align-items-lg-start mb-4 mb-lg-0 font-14 footer-line-height">
            <div className="font-16 font-weight-bold">Developer</div>
            <a target="_blank" rel="noopener noreferrer" href="https://api.payportal.org/">Documentation</a>
          </div>
          <div className="d-flex flex-column align-items-center align-items-lg-start font-14 footer-line-height">
            <div className="font-16 font-weight-bold">Company</div>
            <a target="_blank" rel="noopener noreferrer" href="https://policies.payportal.org">Privacy Policy</a>
            <a target="_blank" rel="noopener noreferrer" href="https://policies.payportal.org">Terms & Conditions</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
